const defaultGroupSettings = {
  savingsCashOutType: "Share based",
  fineCashOutType: "Equally",
  welfareCashOutType: "Equally",
  membershipCashOutType: "Refund",
  loanInterestCashOutType: "Share based",
}

const manifestURLs = {
  production: "/manifest.json",
  staging: "/manifest.staging.json",
  uat: "/manifest.uat.json",
  development: "/manifest.staging.json",
}


const getUserIPData = async () => {
  try {
    const response = await fetch(
      `https://ipinfo.io/json?token=${window.REACT_APP_PWA_IPINFO_ACCESS_KEY}`,
    )
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`)
    }
    const data = await response.json()
    localStorage.setItem("_country", data.country)
    localStorage.setItem("_ip", data.ip)
  } catch (err) {
    console.log("error: ", err)
  }
}

// to be replaced by the below function
const getUserGeoData = (
  success,
  errors,
  options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  },
) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, errors, options)
  }
}

const getGeolocation = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject)
  })

const getNestedObject = (nestedObj, pathArr, defaultReturn = {}) => {
  const data = pathArr.reduce(
    (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined),
    nestedObj,
  )
  return data || defaultReturn
}

const countryMap = {
  NI: "Niger",
  TZ: "Tanzania",
  RW: "Rwanda",
  ZM: "Zambia",
  HN: "Honduras",
  NG: "Nigeria",
  LB: "Lebanon",
  MZ: "Moçambique",
  GH: "Ghana",
  // Add other country codes and names as needed
}

// Function to get the country name based on the code
const getCountryName = (countryCode) => {
  return countryMap[countryCode] || "N/A"
}

const isIndexedDBSupported = () => {
  return "indexedDB" in window
}

const navigationMap = {
  group: {
    main: { backPage: null },
    meetings: { backPage: "main" },
    funds: { backPage: "details" },
    settings: { backPage: "details" },
    details: { backPage: "vslaMenu" },
    overview: { backPage: "memberActions" },
    memberList: { backPage: "details" },
    memberActions: { backPage: "memberList" },
    buyShares: { backPage: "memberActions" },
    sellShares: { backPage: "memberActions" },
    payFine: { backPage: "memberActions" },
    requestWelfare: { backPage: "memberActions" },
    addWelfare: { backPage: "memberActions" },
    addAgri: { backPage: "memberActions" },
    createLoan: { backPage: "memberActions" },
    repayLoan: { backPage: "memberActions" },
    membershipFee: { backPage: "memberActions" },
    addGroupIncome: { backPage: "memberActions" },
    addGroupExpense: { backPage: "memberActions" },
    writeOffLoan: { backPage: "memberActions" },
    cashOut: { backPage: "memberActions" },
    vslaMenu: { backPage: "main" },
    meetingsMenu: { backPage: "details" },
    learningPage: { backPage: "vslaMenu" },
    lessonsPage: { backPage: "learningPage" },
    lessonPage: { backPage: "lessonsPage" },
    previousMeetings: { backPage: "meetingsMenu" },
    createMeeting: { backPage: "meetingsMenu" },
    previousMeetingsItem: { backPage: "previousMeetings" },
    meetingTransactions: { backPage: "memberList" },
    addMember: { backPage: "addMemberMenu" },
    addMemberMenu: { backPage: "memberList" },
    addExistingMembers: { backPage: "addMemberMenu" },
    assignMemberRoles: { backPage: "addExistingMembers" },
    offlineMeeting: { backPage: "meetingsMenu" },
    cashOutError: { backPage: "memberList" },
    endOfCycleCashout: { backPage: "memberList" },
    createGroup: { backPage: "main" },
    addFunds: { backPage: "main" },
  },
}

const getCoursesById = (id, courses, lang) =>
  courses
    ? courses.filter(
        ({ category, Language }) =>
          lang.some((langName) => Language.includes(langName)) && category[0] === id,
      )
    : []

export {
  getCoursesById,
  manifestURLs,
  navigationMap,
  getUserIPData,
  getGeolocation,
  getUserGeoData,
  defaultGroupSettings,
  getNestedObject,
  getCountryName,
  isIndexedDBSupported,
}
